import React from "react";
import axios from 'axios';
import $, { timers } from "jquery";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import Select from 'react-select';
import AEPSSearch from "./AEPSSearch";
import AEPSForm from "./AEPSForm";
import '../AEPSComponent/aeps.css';
import AEPSTxnHistory from "./AEPSTxnHistory";
import { setAepsSection } from "../../redux/aeps/aeps.action";
import AEPSMinistatement from "./AEPSMinistatement";
import * as Spinner from 'react-spinkit';
import AEPSBalanceEnquiry from "./AEPSBalanceEnquiry";
import AepsYbl from "./AepsYbl";
import biometryPaysprint from "./biometry-paysprint";
import AepsTxnHistory1 from "./AepsTxnHistory1";
import AEPSForm1 from "./AEPSForm1";
import MerchantRegister from "./MerchantRegister";
import MerchantCash2FA from "./MerchantCash2FA";

const httpClient = axios.create();
class AEPS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        }
    }



    errorMessageCall = (message) => {
        this.setState({
            displayErrorMsg: message
        })
    }

    enterMobileNumber = (event) => {
        this.setState({
            mobile: event.target.value
        })
    }

    componentDidMount() {
        store.dispatch(setAepsSection('txnHistory'));


    }
    componentDidUnmount() {


    }
    componentWillUnmount() {
    }


    checkBioMetryConnectedStatus = () => {

    }

    enterAmount = (event) => {
        this.setState({
            enteredAmount: event.target.value
        })
    }




    render() {
        return (

            <div>
                <HeadeCommon />
                <Menu />
                <div class="main">
                    <div class="container-fluid">
                        <div class="row">
                            <AEPSSearch />
                            {
                                this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                this.props.aepsSection == 'txnHistory' &&
                                <AEPSTxnHistory />
                            }

                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'aepsForm') &&
                                <AEPSForm />
                            }
                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'aepsFormYbl') &&
                                <AepsYbl />
                            }
                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'ministatement') &&
                                <AEPSMinistatement />
                            }
                            
                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'balanceEnquiry') &&
                                <AEPSBalanceEnquiry />
                            }
                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'merchant-register') &&
                                <MerchantRegister />
                            }
                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'cash-2FA') &&
                                <MerchantCash2FA />
                            }
                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                (this.props.aepsSection == 'cash-2FA-balance') &&
                                <MerchantCash2FA />
                            }


                        </div>
                    </div>


                </div>


                <FooterComponet />
            </div>





        );
    }
}

const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token },
    aepsReduce: { aepsSection, driverStatus }
}
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, aepsSection, driverStatus
});

export default connect(mapStateToProps, null)(AEPS);

